import { createSlice } from '@reduxjs/toolkit';
import { ClaimsGridStateType } from 'src/types/claimsGrid';

const initialState: ClaimsGridStateType = {
    data: null,
    allProviders: false,
    archive: false,
    loading: false,
    error: false,
};
export const claimsGridSlice = createSlice({
    name: 'claimsGrid',
    initialState,
    reducers: {
        getClaimsGridFetch: (state, action) => {
            state.loading = true;
            state.error = false;
            if (action.payload) {
                state.allProviders = action.payload.allProviders;
                state.archive = !!action.payload.archive;
            }
        },
        getClaimsGridFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getClaimsGridFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const { getClaimsGridFetch, getClaimsGridFetchSuccess, getClaimsGridFetchFailure } = claimsGridSlice.actions;

export default claimsGridSlice.reducer;
